import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoEmployee} from "./models/DtoEmployee";
import {EmployeeService} from "./employee.service";
import {DtoEmployeeBaseItems} from "./models/DtoEmployeeBaseItems";
import {Router, ActivatedRoute} from "@angular/router";
import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {FormService} from "../../../fw/services/form.service";
import {SharedService} from "../../shared/shared.service";
import 'rxjs/add/operator/switchMap';
import {SharedValidators} from "../../shared/shared-validators";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {Observable} from "rxjs/Observable";
import {ValidationMessageComponent} from "../../shared/validation-message.component";
import {ContractType} from "../../shared/enums/contractType";
import {EmployeeSalaryComponent} from "./employee-salary.component";
import {DtoSalaryMutation} from "./models/DtoSalaryMutation";
import {DialogService} from "@progress/kendo-angular-dialog";
import {ButtonDefinition} from "../../../fw/buttons/button-definition";
import {DtoEmployeeInactivitiesForYear} from "./models/DtoEmployeeInactivitiesForYear";
import {DtoEmployeeSickForYear} from "./models/DtoEmployeeSickForYear";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {DtoCustomerAppointment} from "../../shared/models/DtoCustomerAppointment";
import {AppointmentListComponent} from "../../shared/appointment-list.component";

@Component({
    selector: 'app-employees-employee',
    template: require('./employee.component.html'),
    styles: [require('./employee.component.css')]
})

@AutoUnsubscribe()
export class EmployeeComponent implements OnInit {
    @ViewChild('gridCostsHistory', {static: false}) grid: DynamicGridComponent;
    @ViewChild('gridInactivities', {static: false}) gridInactivities: DynamicGridComponent;
    @ViewChild('gridSick', {static: false}) gridSick: DynamicGridComponent;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridAvailability', {static: false}) gridAvailability: DynamicGridComponent;
    @ViewChild('gridSalaryMutations', {static: false}) gridSalaryMutations: DynamicGridComponent;
    baseItems: DtoEmployeeBaseItems;
    id: number;
    dtoObject: DtoEmployee;
    form: FormGroup = this.fb.group({
        initials: null,
        employeeNo: [null],
        firstName: null,
        infix: null,
        lastName: [null, [SharedValidators.customRequired]],
        telPersonal: null,
        telMobile: null,
        email: null,
        birthdate: null,
        gender: null,
        remarks: null,
        recActive: null,
        street: null,
        houseNo: null,
        houseNoAdd: null,
        zipcode: null,
        city: null,
        countryId: null,
        useInPlanner: null,
        useInOnlinePlanner: null,
        index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
        startDate: null,
        endDate: null,
        endTrialDate: null,
        contractType: [null, [], [this.validateContractType.bind(this)]],
        contractEndReason: null,
        workLevel: null,
        hasCompetenceDiploma: null,
        hasEntrepreneursDiploma: null,
        iban: null,
        civilState: null,
        taxDiscount: null,
        bsn: null,
        legitimation: null,
        legitimationUntill: null,
        bhv: null,
        bhvUntill: null,
        var: null,
        studieContract: null,
        contractCaoHours: null,
        contract1From: null,
        contract1Untill: null,
        contract2From: null,
        contract2Untill: null,
        contract3From: null,
        contract3Untill: null,
        workdaysPerWeek: null,
        brutoSalary: null,
        brutoHourSalaryIncl: null,
        placementFeePerDay: null,
        salaryRemarks: null,
        extraHolidays: null,
        travelCosts: null,
        travelCostsFeePerKm: null,
        travelCostsDistance: null,
        travelCostsWorkableDays: null,
        travelCostsPerMonth: null,
        travelCostsFeeOV: null,
        password: null,
        brutoSalaryExtraPerHour: null,
        extraSalaryUntaxed: null,
        extraSalaryTaxed: null,
        caoEntityId: null,
        caoExperienceId: null,
        salaryEmployerTax: null,
        travelCostsUntaxed: null,
        travelCostsTaxed: null,
        caoHolidays: null,
        employeeType: null
    });
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'HOOFDGEGEVENS',
        buttonDefinition: [
            {
                description: 'OPSLAAN',
                isSmall: false,
                clickEventType: 'save'
            },
            {
                description: 'ANNULEREN',
                isSmall: false,
                clickEventType: 'cancel'
            }
        ]
    };
    configSalaryMutations: PageSubheaderBarConfig = {
        title: 'LOONKOSTEN',
        buttonDefinition: [
            {
                clickEventType: 'create',
                description: 'TOEVOEGEN',
                isSmall: false
            },
            {
                clickEventType: 'edit',
                description: 'WIJZIGEN',
                isSmall: false
            },
            {
                clickEventType: 'delete',
                description: 'VERWIJDEREN',
                isSmall: false
            }
        ]
    };
    salaryMutationsColumnDefinition: ColumnDefinition[] = [
        {
            key: 'mutationDateTime',
            label: 'Ingangsdatum',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'contractHours',
            label: 'Contr. uren',
            type: 'number',
            width: 'auto'
        },
        {
            key: 'caoEntityDescription',
            label: 'CAO-groep',
            type: 'string',
            width: '*'
        },
        {
            key: 'caoExperienceDescription',
            label: 'Ervaring',
            type: 'string',
            width: '*'
        },
        {
            key: 'brutoCAOHourSalary',
            label: 'CAO uurloon',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'brutoHourSalaryExtra',
            label: 'Extra uurloon',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'brutoCAOSalary',
            label: 'Bruto loon',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'travelCostsTaxed',
            label: 'Belaste reiskosten',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'travelCostsUntaxed',
            label: 'Onbelaste reiskosten',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'extraSalaryUntaxed',
            label: 'Onbelaste verg.',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'extraSalaryTaxedCosts',
            label: 'Belaste verg.',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'employerCosts',
            label: 'Werkgeversdeel',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        },
        {
            key: 'totalSalaryCosts',
            label: 'Tot. loonkosten',
            type: 'number',
            width: 'auto',
            format: '{0:c}'
        }
    ];
    yesNoItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    inactivityYears: Array<{ text: string, value: number }> = [];
    travelCostsItems: Array<{ text: string, value: string }> = [
        { text: 'Ja, KM vergoeding', value: 'Ja, KM vergoeding' },
        { text: 'Ja, KM vergoeding CAO', value: 'Ja, KM vergoeding CAO' },
        { text: 'Ja, OV vergoeding', value: 'Ja, OV vergoeding' },
        { text: 'Nee', value: 'Nee' }
    ];
    availabilityColumnDefinition: ColumnDefinition[] = [
        {
            key: 'hasAccess',
            label: 'Beschikbaar',
            type: 'boolean',
            width: '150px',
            enabled: true
        },
        {
            key: 'companyName',
            label: 'Filiaal',
            type: 'string',
            width: '*'
        }
    ];
    inactivitiesColumnDefinition: ColumnDefinition[] = [
        {
            key: 'from',
            label: 'Van',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'untill',
            label: 'Tot en met',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'holidayHours',
            label: 'Vakantieuren',
            type: 'string',
            width: '130px'
        },
        {
            key: 'typeDescription',
            label: 'Type',
            type: 'string',
            width: '130px'
        },
        {
            key: 'kindDescription',
            label: 'Soort',
            type: 'string',
            width: '200px'
        },
        {
            key: 'branch',
            label: 'Filiaal',
            type: 'string',
            width: '250px'
        },
        {
            key: 'remarks',
            label: 'Opmerkingen',
            type: 'string',
            width: '*'
        }
    ];
    sickColumnDefinition: ColumnDefinition[] = [
        {
            key: 'from',
            label: 'Van',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'untill',
            label: 'Tot en met',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'sickTime',
            label: 'Uren',
            type: 'string',
            width: '130px'
        },
        {
            key: 'branch',
            label: 'Filiaal',
            type: 'string',
            width: '250px'
        },
        {
            key: 'remarks',
            label: 'Opmerkingen',
            type: 'string',
            width: '*'
        }
    ];
    formFilterInactivities: FormGroup;
    formFilterSick: FormGroup;
    inactivityButtonDefinition: ButtonDefinition[] = [
        /*
            clickEventType: 'copyLastYear',
            description: 'OVERNAME VORIG JAAR',
            isSmall: false
        },
        {
            clickEventType: 'manualAdjustment',
            description: 'HANDMATIG AANPASSEN',
            isSmall: false
        },
        {
            clickEventType: 'create',
            description: 'LANGDURIG VERLOF',
            isSmall: false
        },
        {
            clickEventType: 'edit',
            description: 'WIJZIGEN',
            isSmall: false
        },
        {
            clickEventType: 'delete',
            description: 'VERWIJDEREN',
            isSmall: false
        }*/
    ];
    sickButtonDefinition: ButtonDefinition[] = [
        /*
            clickEventType: 'copyLastYear',
            description: 'OVERNAME VORIG JAAR',
            isSmall: false
        },
        {
            clickEventType: 'manualAdjustment',
            description: 'HANDMATIG AANPASSEN',
            isSmall: false
        },
        {
            clickEventType: 'create',
            description: 'LANGDURIG VERLOF',
            isSmall: false
        },
        {
            clickEventType: 'edit',
            description: 'WIJZIGEN',
            isSmall: false
        },
        {
            clickEventType: 'delete',
            description: 'VERWIJDEREN',
            isSmall: false
        }*/
    ];
    currentInactivities: DtoEmployeeInactivitiesForYear;
    currentSick: DtoEmployeeSickForYear;
    salaryMutations: DtoSalaryMutation[];
    travelCostsFeePerKmDisabled: boolean;
    travelCostsFeeOVDisabled: boolean;
    travelCostsFeeOVVisible: boolean;
    travelCostsPerMonthDisabled: boolean;
    travelCostsDistanceDisabled: boolean;
    travelCostsWorkdays: number;

    constructor(private breadcrumService: BreadcrumService,
                private ds: EmployeeService,
                private fb: FormBuilder,
                private fs: FormService,
                private ss: SharedService,
                private router: Router,
                private route: ActivatedRoute,
                private dialogService: DialogService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'medewerkers', isLastStep: false },
            { text: '', isLastStep: true }];

        for (let i = 0; i < 5; i++) {
            this.inactivityYears.push({
                text: (this.ss.getCurrentYear() - i).toString(),
                value: this.ss.getCurrentYear() - i
            });
        }
        this.breadcrumService.setCurrentLocation(steps, true, 'employee-list');

        this.id = parseInt(this.route.snapshot.paramMap.get('id'));
        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );
        this.formFilterInactivities = this.fb.group({
            year: this.ss.getCurrentYear()
        });
        this.formFilterInactivities.get('year').valueChanges.subscribe(() => {
            this.loadInactivities(true);
        });
        this.formFilterSick = this.fb.group({
            year: this.ss.getCurrentYear()
        });
        this.formFilterSick.get('year').valueChanges.subscribe(() => {
            this.loadSick(true);
        });
        this.form.get('travelCosts').valueChanges.subscribe(newVal => {
            this.setTravelCostsBoxes(newVal);
        });
        this.form.get('travelCostsDistance').valueChanges.subscribe(() => {
            this.calculateTravelCosts();
        });
        this.form.get('travelCostsFeePerKm').valueChanges.subscribe(() => {
            this.calculateTravelCosts();
        });

        this.getBaseItems();
        setTimeout(() => {
            this.loadData();
        });
    }

    getBaseItems() {
        this.ds.getEmployeeBaseItems(false).subscribe(response => {
            this.baseItems = response;
            if (this.dtoObject && this.dtoObject.id == 0) {
                if (this.baseItems.defaultCountryId) {
                    this.dtoObject.countryId = this.baseItems.defaultCountryId;
                }
            }
        });
    }

    getBranchAvailability() {
        let result = [];
        this.gridAvailability.getData().forEach(item => {
            if (item.hasAccess) {
                result.push({
                   userId: item.id
                });
            }
        });

        return result;
    }

    setBranchAvailability() {
        this.baseItems.branches.forEach(item => {
            item.hasAccess = this.dtoObject.employeeBranchAvailabilities.some(x => x.userId == item.id);
        });
        this.gridAvailability.showData(this.baseItems.branches);
    }

    tabSelected(e) {
        if (e.index == 2) {
            this.loadSalaryMutations(false);
        } else if (e.index == 4) {
            this.loadInactivities(false);
        } else if (e.index == 5) {
            this.loadSick(false);
        }
    }

    loadData() {
        if (this.id > 0) {
            this.ds.getEmployeeById(this.id).subscribe((res: DtoEmployee) => {
                this.dtoObject = res;
                this.breadcrumService.setLastStepDescription(this.getEmployeeName());
                this.fs.patchDtoToForm(this.dtoObject, this.form);
                this.getCaoHolidaysDisabled();
                this.loadSalaryMutations(false);
                this.setBranchAvailability();
            });
        } else {
            this.ds.getEmployeeNextIndex().subscribe(res => {
                this.dtoObject = {
                    id: 0,
                    index: res,
                    recActive: true,
                    salaryEmployerTax: 30,
                    useInPlanner: true,
                    useInOnlinePlanner: true,
                    employeeBranchAvailabilities: [],
                    salaryMutations: []
                } as DtoEmployee;
                this.fs.patchDtoToForm(this.dtoObject, this.form);
            });
        }

    }

    phbBtnClicked(event) {
        if (event == 'save') {
            this.validationMessage.validateForm();

            if (this.form.valid) {
                let result = this.fs.patchFormToDto(this.dtoObject, this.form);
                this.preCheckSave(result);
            }
        } else if (event == 'cancel') {
            this.router.navigate(['/auth/employee-list']);
        }
    }

    preCheckSave(objectToSave: DtoEmployee) {
        let branchCheck = this.getBranchesNotAvailableAnymore();
        if (this.form.get('endDate').value || !this.form.get('useInPlanner').value || !objectToSave.recActive) {
            let checkDate = this.form.get('endDate').value;
            if (!checkDate) checkDate = this.ss.getCurrentDate();
            this.ds.getAppointmentsFromDate(this.id, checkDate).subscribe((res: DtoCustomerAppointment[]) => {
                if (res.length > 0) {
                    this.showAppointmentList(res, checkDate);
                } else {
                    if (!objectToSave.recActive) {
                        this.ss.confirm('Indien u een medewerker op inactief zet, worden verlof- en urenregistraties na vandaag automatisch verwijderd.').subscribe(res => {
                            if (res) {
                                this.saveEmployee(objectToSave);
                            }
                        });
                    } else {
                        if (this.form.get('endDate').value) {
                            this.ss.confirm('Indien u een datum uit dienst invoert, worden verlof- en urenregistraties na deze datum automatisch verwijderd.').subscribe(res => {
                                if (res) {
                                    this.saveEmployee(objectToSave);
                                }
                            });
                        } else
                            this.saveEmployee(objectToSave);
                    }
                }
            })
        } else if (branchCheck.length > 0) {
            this.ds.getFutureAppointmentsForBranches(this.id, branchCheck).subscribe((res: DtoCustomerAppointment[]) => {
                if (res.length > 0) {
                    this.showAppointmentListBranch(res, this.ss.getCurrentDate());
                } else {
                    if (!objectToSave.recActive) {
                        this.ss.confirm('Indien u een medewerker op inactief zet, worden verlof- en urenregistraties na vandaag automatisch verwijderd.').subscribe(res => {
                            if (res) {
                                this.saveEmployee(objectToSave);
                            }
                        });
                    } else {
                        if (this.form.get('endDate').value) {
                            this.ss.confirm('Indien u een datum uit dienst invoert, worden verlof- en urenregistraties na deze datum automatisch verwijderd.').subscribe(res => {
                                if (res) {
                                    this.saveEmployee(objectToSave);
                                }
                            });
                        } else
                            this.saveEmployee(objectToSave);
                    }
                }
            });
        } else {
            this.saveEmployee(objectToSave);
        }
    }

    saveEmployee(objectToSave: DtoEmployee) {
        objectToSave.employeeBranchAvailabilities = this.getBranchAvailability();
        this.ds.saveEmployee(objectToSave)
            .subscribe(response => {
                if (!response.hasError) {
                    this.router.navigate(['/auth/employee-list']);
                }
                else {
                    this.ss.message(response.errorMessage);
                }
            });
    }

    getBranchesNotAvailableAnymore(): number[] {
        let result = [];
        const newBranches = this.getBranchAvailability();
        this.dtoObject.employeeBranchAvailabilities.forEach(branch => {
            if (!newBranches.some(x => x.userId == branch.userId))
                result.push(branch.userId);
        });

        return result;
    }

    showAppointmentList(data: DtoCustomerAppointment[], date: Date) {
        const dialogRef = this.dialogService.open({
            content: AppointmentListComponent
        });

        const dialogContent: AppointmentListComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.employeeId = this.id;
        dialogContent.data = data;
        dialogContent.from = date;
        dialogContent.untill = date;
        dialogContent.title = 'Afspraken in de toekomst';
        dialogContent.caller = 'EmployeeComponent';
        dialogContent.infoText = 'Er staan nog afspraken in de toekomst bij deze medewerker. Verzet de onderstaande afspraken eerst voordat u de medewerker uit de agenda haalt.';

        dialogRef.result.subscribe(() => {
            this.router.navigate(['/auth/employee-list']);
        });
    }

    showAppointmentListBranch(data: DtoCustomerAppointment[], date: Date) {
        const dialogRef = this.dialogService.open({
            content: AppointmentListComponent
        });

        const dialogContent: AppointmentListComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.employeeId = this.id;
        dialogContent.data = data;
        dialogContent.from = date;
        dialogContent.untill = date;
        dialogContent.title = 'Afspraken in filiaal zonder beschikbaarheid';
        dialogContent.caller = 'EmployeeComponent';
        dialogContent.infoText = 'Er staan nog afspraken bij deze medewerker welke plaatsvinden in een filiaal waar de medewerker niet als beschikbaar staat aangegeven. Verzet de onderstaande afspraken eerst voordat u de medewerker uit de agenda haalt.';

        dialogRef.result.subscribe(() => {
            this.router.navigate(['/auth/employee-list']);
        });
    }

    getEmployeeName() {
        if (this.dtoObject) {
            let result = this.dtoObject.firstName;
            if (this.dtoObject.infix) {
                if (result && result.length > 0)
                    result += ' ' + this.dtoObject.infix;
                else
                    result = this.dtoObject.infix;
            }
            if (this.dtoObject.lastName) {
                if (result && result.length > 0)
                    result += ' ' + this.dtoObject.lastName;
                else
                    result = this.dtoObject.lastName;
            }
            return result;
        } else {
            return '';
        }
    }

    getEmployeeAddress() {
        if (this.dtoObject) {
            let result = this.dtoObject.street;
            if (this.dtoObject.houseNo) {
                if (result && result.length > 0)
                    result += ' ' + this.dtoObject.houseNo.toString();
                else
                    result = this.dtoObject.houseNo.toString();
            }
            if (this.dtoObject.houseNoAdd) {
                    result += this.dtoObject.houseNoAdd;
            }
            if (this.dtoObject.zipcode) {
                if (result && result.length > 0)
                    result += ' ' + this.dtoObject.zipcode;
                else
                    result = this.dtoObject.zipcode;
            }
            if (this.dtoObject.city) {
                if (result && result.length > 0)
                    result += ' ' + this.dtoObject.city;
                else
                    result = this.dtoObject.city;
            }
            return result;
        } else
            return '';
    }

    getEmployeePhoneNo() {
        if (this.dtoObject) {
            if (this.dtoObject.telMobile)
                return this.dtoObject.telMobile;
            else if (this.dtoObject.telPersonal)
                return this.dtoObject.telPersonal;
            else
                return '';
        } else
            return '';
    }

    getEmployeeBirthdate() {
        if (this.dtoObject && this.dtoObject.birthdate) {
            return this.ss.formatDate(this.dtoObject.birthdate) + ' (' + this.ss.getAge(this.dtoObject.birthdate) + ')';
        } else
            return '';
    }

    calculateCurrentHours() {
        if (this.dtoObject) {
            if (this.form.get('contractCaoHours').value > 0) {
                this.dtoObject.currentParttime = this.ss.round((this.dtoObject.currentContractHours / this.form.get('contractCaoHours').value), 2);
            }

            if (this.dtoObject.currentContractHours > 0) {
                this.dtoObject.currentHoursPerPeriod = this.ss.round((this.dtoObject.currentContractHours * 52) / 12, 0);
            }

            this.dtoObject.currentStandardHolidayHours = this.calculateStandardHolidayHours(this.ss.getCurrentYear());

            this.dtoObject.currentTotalHolidayHours = this.ss.round(this.dtoObject.currentStandardHolidayHours + this.form.get('extraHolidays').value, 1);
        }
    }

    calculateCurrentContractHours() {
        if (this.salaryMutations && this.salaryMutations.length > 0) {
            return this.salaryMutations.sort(x => x.mutationDateTime.getTime()).reverse()[0].contractHours;
        }

        return 0;
    }

    getCaoHolidaysDisabled() {
        if (this.dtoObject && this.baseItems) {
            if (this.form.get('caoEntityId').value && this.baseItems.caoEntities.find(x => x.id == this.form.get('caoEntityId').value).branch != 0)
                this.form.get('caoHolidays').disable();
            else
                this.form.get('caoHolidays').enable();
        } else
            this.form.get('caoHolidays').disable();
    }

    calculateStandardHolidayHours(year: number) {
        if (this.dtoObject && this.salaryMutations) {
            let result = 0;
            let startweek = new Date(year, 0, 1);
            let endweek = new Date(year, 11, 31);
            if (this.form.get('startDate').value && this.ss.getFirstDayOfYear(this.form.get('startDate').value).getFullYear() == year)
                startweek = this.form.get('startDate').value;
            if (this.form.get('endDate').value && this.ss.getFirstDayOfYear(this.form.get('endDate').value).getFullYear() == year)
                endweek = this.ss.addDaysToDate(this.form.get('endDate').value, -1);

            let daysOfYear = this.ss.getDayOfYear(endweek);

            for (let item of this.salaryMutations.filter(x => x.mutationDateTime.getDate() <= endweek.getDate()).sort((a, b) => new Date(b.mutationDateTime).getTime() - new Date(a.mutationDateTime).getTime())) {
                if (item.mutationDateTime.getDate() <= endweek.getDate()) {
                    let tempHoliday = this.ss.round((item.contractHours / 5) * this.form.get('caoHolidays').value, 1);
                    if (item.mutationDateTime.getFullYear() < year || item.mutationDateTime.getDate() <= startweek.getDate()) {
                        result += this.ss.round(((this.ss.getDayOfYear(endweek) - (this.ss.getDayOfYear(startweek) - 1)) / daysOfYear) * tempHoliday, 1);
                        break;
                    } else {
                        result += this.ss.round(((this.ss.getDayOfYear(endweek) - (this.ss.getDayOfYear(item.mutationDateTime) - 1)) / daysOfYear) * tempHoliday, 1);
                        endweek = this.ss.addDaysToDate(item.mutationDateTime, -1);
                    }
                }
            }

            return result;
        }

        return 0;
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkEmployeeIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateContractType(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && this.dtoObject.contractType == ContractType.ZEROHOUR && control.dirty && control.value != null && !control.value) {
                this.ds.hasContracts(this.dtoObject.id)
                    .subscribe((response: boolean) => {
                        observer.next(response ? { noZeroContractPossible: true } : null);
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    // SALARYMUTATIONS
    loadSalaryMutations(reload: boolean) {
        if (reload || !this.salaryMutations) {
            this.ds.getEmployeeSalaryMutations(this.id).subscribe((res: DtoSalaryMutation[]) => {
                this.salaryMutations = res;
                this.calculateCurrentHours();
                this.showSalaryMutations();
            });
        }
    }

    showSalaryMutations() {
        this.setSalaryMutationCaoDescriptions();
        if (this.gridSalaryMutations)
            this.gridSalaryMutations.showData(this.salaryMutations.sort((a, b) => b.mutationDateTime.getTime() - a.mutationDateTime.getTime()));
    }

    setSalaryMutationCaoDescriptions() {
        if (this.baseItems && this.salaryMutations) {
            this.salaryMutations.forEach(item => {
                if (item.caoEntityId) {
                    item.caoEntityDescription = this.baseItems.caoEntities.find(
                        x => x.id == item.caoEntityId
                    ).description;
                }
                if (item.caoExperienceId) {
                    item.caoExperienceDescription = this.baseItems.caoExperiences.find(
                        x => x.id == item.caoExperienceId
                    ).description;
                }
            });
        }
    }

    pageSalaryMutationsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showSalaryMutationEditWindow(null);
        } else if (event == 'edit') {
            if (this.gridSalaryMutations.getSelectedItem()) {
                this.showSalaryMutationEditWindow(this.gridSalaryMutations.getSelectedItem());
            }
        } else if (event == 'delete') {
            if (this.gridSalaryMutations.getSelectedItem()) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEmployeeSalaryMutations(this.gridSalaryMutations.getSelectedItem().id).subscribe((res: DtoDeleteResult) => {
                                if (res.isDeleted) {
                                    this.salaryMutations.splice(this.salaryMutations.indexOf(this.gridSalaryMutations.getSelectedItem()), 1);
                                    this.gridSalaryMutations.showData(this.salaryMutations);
                                    this.calculateCurrentHours();
                                } else {
                                    this.ss.message(res.infoMessage);
                                }
                            });
                        }
                    });
            }
        }
    }

    pageSalaryMutationsGridRowDoubleClicked(event: number) {
        this.pageSalaryMutationsBtnHeaderBarClicked('edit');
    }

    showSalaryMutationEditWindow(salaryObject: DtoSalaryMutation) {
        const dialogRef = this.dialogService.open({
            content: EmployeeSalaryComponent
        });

        let isNewObject = false;
        if (!salaryObject) {
            salaryObject = {
                id: 0,
                mutationDateTime: this.ss.getCurrentDate(),
                contractHours: 0,
                travelCostsUntaxed: this.getUntaxedTravelCosts(),
                travelCostsTaxed: this.getTaxedTravelCosts(),
                employeeId: this.dtoObject.id
            };
            isNewObject = true;
        }

        const dialogContent: EmployeeSalaryComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.baseItems = this.baseItems;
        dialogContent.birthDate = this.form.get('birthdate').value;
        dialogContent.currentCaoHolidayHours = this.form.get('contractCaoHours').value;
        dialogContent.dtoObject = salaryObject;

        dialogContent.salarySaved
            .subscribe((result: DtoSalaryMutation) => {
                if (isNewObject) {
                    this.salaryMutations.push(result);
                } else {
                    let currentIndex = this.salaryMutations.indexOf(salaryObject);
                    if (this.salaryMutations[currentIndex]) {
                        this.salaryMutations[currentIndex] = result;
                    }
                }

                this.form.patchValue({ ['caoEntityId']: result.caoEntityId }, {emitEvent: false});
                this.getCaoHolidaysDisabled();
                if (this.form.get('caoHolidays').disabled) // only set hours when it's CAO based
                    this.form.patchValue({ ['caoHolidays']: result.caoHolidays }, {emitEvent: false});

                this.showSalaryMutations();
                this.dtoObject.currentContractHours = this.calculateCurrentContractHours();
                this.calculateCurrentHours();
            });
    }

    // INACTIVITIES
    loadInactivities(reload: boolean) {
        if (reload || !this.currentInactivities) {
            this.gridInactivities.clearData();
            this.currentInactivities = null;
            this.ds.getEmployeeInactivities(this.dtoObject.id, this.formFilterInactivities.get('year').value).subscribe((res: DtoEmployeeInactivitiesForYear) => {
                this.currentInactivities = res;
                this.gridInactivities.showData(this.currentInactivities.inactivitiesThisYear);
            });
        }
    }

    // SICK
    loadSick(reload: boolean) {
        if (reload || !this.currentSick) {
            this.gridSick.clearData();
            this.currentSick = null;
            this.ds.getEmployeeSick(this.dtoObject.id, this.formFilterSick.get('year').value).subscribe((res: DtoEmployeeSickForYear) => {
                this.currentSick = res;
                this.gridSick.showData(this.currentSick.sickThisYear);
            });
        }
    }

    // TRAVEL
    setTravelCostsBoxes(value: string) {
        if (value == 'Nee') {
            this.travelCostsFeePerKmDisabled = true;
            this.travelCostsPerMonthDisabled = true;
            this.travelCostsFeeOVDisabled = true;
            this.travelCostsDistanceDisabled = true;
            this.travelCostsFeeOVVisible = false;
            this.form.patchValue({ ['travelCostsFeePerKm']: 0 });
            this.form.patchValue({ ['travelCostsDistance']: 0 });
            this.form.patchValue({ ['travelCostsPerMonth']: 0 });
            this.form.patchValue({ ['travelCostsFeeOV']: 0 });
            this.travelCostsWorkdays = 0;
        } else if (value == 'Ja, KM vergoeding') {
            this.travelCostsFeePerKmDisabled = false;
            this.travelCostsDistanceDisabled = false;
            this.travelCostsPerMonthDisabled = true;
            this.travelCostsFeeOVDisabled = true;
            this.travelCostsFeeOVVisible = false;
            this.form.patchValue({ ['travelCostsPerMonth']: 0 });
            this.form.patchValue({ ['travelCostsFeeOV']: 0 });
            this.travelCostsWorkdays = this.form.get('workdaysPerWeek').value;
            this.calculateTravelCosts();
        } else if (value == 'Ja, KM vergoeding CAO') {
            this.travelCostsFeePerKmDisabled = true;
            this.travelCostsDistanceDisabled = false;
            this.travelCostsPerMonthDisabled = false;
            this.travelCostsFeeOVDisabled = true;
            this.travelCostsFeeOVVisible = false;
            this.form.patchValue({ ['travelCostsFeePerKm']: 0 });
            this.form.patchValue({ ['travelCostsFeeOV']: 0 });
            this.travelCostsWorkdays = this.form.get('workdaysPerWeek').value;
        } else if (value == 'Ja, OV vergoeding') {
            this.travelCostsFeePerKmDisabled = true;
            this.travelCostsDistanceDisabled = true;
            this.travelCostsPerMonthDisabled = true;
            this.travelCostsFeeOVDisabled = false;
            this.travelCostsFeeOVVisible = true;
            this.form.patchValue({ ['travelCostsFeePerKm']: 0 });
            this.form.patchValue({ ['travelCostsDistance']: 0 });
            this.form.patchValue({ ['travelCostsPerMonth']: 0 });
            this.travelCostsWorkdays = this.form.get('workdaysPerWeek').value;
        }
    }

    calculateTravelCosts() {
        if (this.form.get('travelCosts').value == 'Ja, KM vergoeding') {
            let totalCosts = this.ss.round((((214 * this.form.get('travelCostsDistance').value) * this.form.get('travelCostsFeePerKm').value) * (this.form.get('workdaysPerWeek').value / 5) / 12), 2);
            this.form.patchValue({ ['travelCostsPerMonth']: totalCosts });
        }
    }

    getTaxedTravelCosts() {
        if (this.form.get('travelCosts').value == 'Ja, KM vergoeding') {
            let travelcostskmTaxed = this.form.get('travelCostsFeePerKm').value - 0.19;
            if (travelcostskmTaxed > 0) {
                return this.ss.round((((214 * this.form.get('travelCostsDistance').value) * travelcostskmTaxed) * (this.form.get('workdaysPerWeek').value / 5) / 12), 2);
            }
        }
        return 0;
    }

    getUntaxedTravelCosts() {
        if (this.form.get('travelCosts').value == 'Ja, KM vergoeding') {
            if (this.form.get('travelCostsFeePerKm').value > 0.19) {
                return this.ss.round((((214 * this.form.get('travelCostsDistance').value) * 0.19) * (this.form.get('workdaysPerWeek').value / 5) / 12), 2);
            } else {
                return this.ss.round((((214 * this.form.get('travelCostsDistance').value) * this.form.get('travelCostsFeePerKm').value) * (this.form.get('workdaysPerWeek').value / 5) / 12), 2);
            }
        }
        return this.form.get('travelCostsPerMonth').value + this.form.get('travelCostsFeeOV').value;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-details/employee.component.ts